export const filterSearchParams = (searchParams, keyValuePairsToAdd = [], keyValuePairsToRemove = []) => {
  keyValuePairsToAdd.forEach(({key, value}) => searchParams.set(key, value));
  const paramsToRemove = [];
  for (const [key, value] of searchParams) {
    const removeKey =
      value === '' || keyValuePairsToRemove.some((pair) => pair.key === key && (!pair.value || pair.value === value));
    if (removeKey) paramsToRemove.push(key);
  }
  paramsToRemove.forEach((key) => searchParams.delete(key));
  return searchParams.toString();
};
